import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map, Observable} from "rxjs";
import { LinkCategory } from "./LinkCategory";

@Injectable({
  providedIn: 'root'
})

export class UsefulLinksService {
  private jsonUrl = 'assets/config_data.json';

  constructor(private http: HttpClient) {}

  getLinkCategories(): Observable<LinkCategory[]> {
    return this.http.get<{ linkCategories: LinkCategory[] }>(this.jsonUrl).pipe(
      map(res => res.linkCategories)
    );
  }
}
